import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../contexts/AuthContext";
import StagesList from "./components/StagesList";
import CreateStageForm from "./components/CreateStageForm";

function Tournament() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [stages, setStages] = useState([]);
  const [activeTab, setActiveTab] = useState("list");
  const { apiBaseUrl } = useAuth();

  const handleGetStages = async () => {
    setLoading(true);
    setMessage("");

    try {
      const response = await axios.get(
        `${apiBaseUrl}/api/tournament/admin/stages`,
        {
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (response.data.data) {
        setStages(response.data.data);
        setMessage("استیج‌ها با موفقیت دریافت شد");
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage(error.response?.data?.message || "خطا در دریافت استیج‌ها");
    } finally {
      setLoading(false);
    }
  };

  const handleStageCreated = () => {
    handleGetStages();
    setActiveTab("list");
  };

  return (
    <div className="space-y-6 p-12">
      <h3 className="text-xl font-semibold text-white mb-6">مدیریت تورنومنت</h3>

      {message && (
        <div
          className={`p-4 rounded-lg text-center ${
            message.includes("موفقیت")
              ? "bg-green-900 border border-green-600 text-green-400"
              : "bg-red-900 border border-red-600 text-red-400"
          }`}
        >
          {message}
        </div>
      )}

      {/* تب‌ها */}
      <div className="flex gap-2 bg-gray-800 rounded-lg p-1">
        <button
          onClick={() => setActiveTab("list")}
          className={`flex-1 py-2 px-4 rounded-md transition duration-200 font-medium ${
            activeTab === "list"
              ? "bg-blue-600 text-white"
              : "text-gray-300 hover:text-white hover:bg-gray-700"
          }`}
        >
          لیست استیج‌ها
        </button>
        <button
          onClick={() => setActiveTab("create")}
          className={`flex-1 py-2 px-4 rounded-md transition duration-200 font-medium ${
            activeTab === "create"
              ? "bg-green-600 text-white"
              : "text-gray-300 hover:text-white hover:bg-gray-700"
          }`}
        >
          ایجاد استیج جدید
        </button>
      </div>

      {/* محتوای تب‌ها */}
      {activeTab === "list" && (
        <StagesList
          stages={stages}
          loading={loading}
          onRefresh={handleGetStages}
        />
      )}

      {activeTab === "create" && (
        <CreateStageForm onSuccess={handleStageCreated} />
      )}
    </div>
  );
}

export default Tournament;
